var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"content-page",attrs:{"id":"content-page"}},[_c('div',{staticClass:"container-fluid p-30px"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }